import React, { useContext, useEffect, useState } from 'react'

import { Row, Col, InputNumber, Button } from 'antd'
import moment from 'moment'
import { useSelector } from 'react-redux'

import QuickDualDatePickers from '../shared/QuickDualDatePickers'
import { getMaxPlacesByPeriod } from '../utils/DataDerivers'
import { getStartDateByType, getEndDateByType } from '../../../../utils/timePeriods'
import StandardSelect, { STRING, WILD_CART_VALUE } from '../../../antd/Selects/StandardSelect'
import { isObject } from '../../../../utils'
import { GlobalContext } from '../../../../Providers/GlobalProvider'
import { createQuota } from '../../../../utils/api/quota'
import { selectUser } from '../../../../reducers/UserReducer'
import { Quota } from '../../../../utils/entities/quota'
import { QuotasContext } from '../../../../Providers/Quotas/QuotasProvider'
import { onError, onSuccess } from '../../../../utils/apiHelper'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

import '../assets/quotas.scss'

export const BODY_STYLE = { display: 'flex', flexDirection: 'column', height: '93%', width: '100%' }
export const SELECT_STYLE = { width: '200px' }

const PLACES_TITLE = 'Allocated places'
const SECTION_TITLE = 'common.section'
const SECTION_KEY = 'abbreviation'
const SCHOOLS_TITLE = 'common.school'
const SCHOOL_KEY = 'name'
const SCHOOL_YEARS_TITLE = 'School year'
const SCHOOL_YEAR_KEY = 'schoolYearName'

const AllocationForm = ({ cell, date, period, places, schools, sector, visible, afterSubmit, onCancel }) => {
  const { sections } = useContext(GlobalContext)
  const { getSchoolYears } = useContext(QuotasContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [schoolYears, setSchoolYears] = useState([])
  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment())
  const [section, setSection] = useState(null)
  const [school, setSchool] = useState(WILD_CART_VALUE)
  const [selectedSchoolYear, setSelectedSchoolYear] = useState(WILD_CART_VALUE)
  const [requirePlaces, setRequirePlaces] = useState(0)
  const [placesPool, setPlacesPool] = useState(0)

  useEffect(() => {
    if (isObject(section)) {
      getSchoolYears(section).then(setSchoolYears)
    } else {
      setSchoolYears([])
    }

    setSelectedSchoolYear(WILD_CART_VALUE)
  }, [section])

  useEffect(() => {
    if ((cell || date) && period) {
      setStartDate(getStartDateByType(cell ? cell.date : date, period.type))
      setEndDate(getEndDateByType(cell ? cell.date : date, period.type))

      if (cell && cell.section) {
        setSection(cell.section)
      }
    }
  }, [cell, date, period])

  useEffect(() => {
    if (places && places.length > 0) {
      setPlacesPool(getMaxPlacesByPeriod(places, startDate, endDate, period, section))
    }
  }, [places, startDate, endDate, period, section])

  const handleSubmit = () => {
    const quota = new Quota({
      school,
      sector,
      section,
      selectedSchoolYear,
      total: requirePlaces,
      startDate,
      endDate
    })

    createQuota(user, quota).then(({ data }) => {
      afterSubmit(data)
      onSuccess(t('The quota has been successfully created'))
    }).catch(() => {
      onError(t('An error was encountered when creating the quota'))
    })
  }

  const handleDatesChange = (dates, dateStrings) => {
    setStartDate(dates[0])
    setEndDate(dates[1])
  }

  return (
    <div className='allocate-quota-form'>
      <QuickDualDatePickers
        startDate={startDate}
        endDate={endDate}
        period={period}
        onDatesChange={handleDatesChange}
      />
      <Row>
        <Col span={12}>
          <h4>
            <b>
              {t(PLACES_TITLE)}
            </b>
          </h4>
        </Col>
        <Col span={12}>
          <InputNumber value={requirePlaces} onChange={setRequirePlaces} />
          <b>{` / ${placesPool ?? 0}`}</b>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h4>
            <b>
              {t(SECTION_TITLE)}
            </b>
          </h4>
        </Col>
        <Col span={12}>
          <StandardSelect
            data={sections}
            dataKey={SECTION_KEY}
            dataType={STRING}
            style={SELECT_STYLE}
            value={isObject(section) ? section[SECTION_KEY] : section}
            onSelect={setSection}
            emptyOption
            showSearch
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h4>
            <b>
              {t(SCHOOLS_TITLE)}
            </b>
          </h4>
        </Col>
        <Col span={12}>
          <StandardSelect
            data={schools}
            dataKey={SCHOOL_KEY}
            dataType={STRING}
            style={SELECT_STYLE}
            value={isObject(school) ? school[SCHOOL_KEY] : school}
            onSelect={setSchool}
            allOption
            showSearch
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h4>
            <b>
              {t(SCHOOL_YEARS_TITLE)}
            </b>
          </h4>
        </Col>
        <Col span={12}>
          <StandardSelect
            data={schoolYears}
            dataKey={SCHOOL_YEAR_KEY}
            dataType={STRING}
            disabled={school === WILD_CART_VALUE || !isObject(section)}
            style={SELECT_STYLE}
            value={isObject(selectedSchoolYear) ? selectedSchoolYear[SCHOOL_YEAR_KEY] : selectedSchoolYear}
            onSelect={setSelectedSchoolYear}
            allOption
            showSearch
          />
        </Col>
      </Row>
      <div className='allocation-form-footer'>
        <Button
          disabled={school === WILD_CART_VALUE}
          type='primary'
          onClick={handleSubmit}
        >
          {t('Create')}
        </Button>
        <Button onClick={onCancel}>
          {t('Cancel')}
        </Button>
      </div>
    </div>
  )
}

export default AllocationForm
